import React from "react";
import { useLocation } from "react-router-dom";
import BannerComponent from "./BannerComponent";

const MosaicPlaceholder: React.FC = () => {
  const location = useLocation();
  const currentPage = location.pathname.slice(1);

  // Define page titles
  const pageTitles = {
    "": "Operation RAILSAFE Partner Training Program",
    courses: "Courses",
    register: "Register for Course",
    "online-course": "Online Partner Training",
    contact: "Contact Us",
    resources: "Resources",
  };

  return (
    <BannerComponent
      title={
        pageTitles[currentPage as keyof typeof pageTitles] ||
        "Amtrak Police Department"
      }
    />
  );
};

export default MosaicPlaceholder;
